import type { DraftOrderListParams } from '../api/draft-orders-api';

/** Store-scoped keys: switching stores never shares cache. */
export const draftOrderKeys = {
  all: (storeId: string) => ['stores', storeId, 'draft-orders'] as const,
  lists: (storeId: string) => [...draftOrderKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: DraftOrderListParams) =>
    [...draftOrderKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...draftOrderKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...draftOrderKeys.details(storeId), id] as const,
  invoicePreviews: (storeId: string, id: string) =>
    [...draftOrderKeys.all(storeId), 'invoice-preview', id] as const,
  invoicePreview: (storeId: string, id: string, message: string) =>
    [...draftOrderKeys.invoicePreviews(storeId, id), message] as const,
  paymentOptions: (storeId: string) => [...draftOrderKeys.all(storeId), 'payment-options'] as const,
};
